import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../../redux/actions/menuActions";
import Menu from "../../accounting/Menu";

import { getExpenseRejectTypes } from "../../../modules/presence/actions/expenseReports";
import Accounting from "../../../modules/presence/expenseReports/Accounting/Accounting";

const AccoutingContainer = props => {
  useEffect(() => {
    props.setMenuLeftContent(Menu);
    props.setMenuLeftIndex("expenseValidation");
    props.setMenuLeftItemIndex("");
  }, []);

  return <Accounting {...props} />;
};

const mapStateToProps = state => {
  const { email } = state.userInfos;
  const available = true;
  // ["tsirizo.rabenoro@upsell.fr", "comptabilite.es@upsell.fr", "thomas.jablonski@upsell.fr"].indexOf(email) > -1;
  return {
    available,
    token: state.auth.token,
    rejectTypes: state.expenseReports.rejectTypes
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    fetchExpenseRejectTypes: () => dispatch(getExpenseRejectTypes())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccoutingContainer);



// WEBPACK FOOTER //
// src/pages/presence/expenseReports/Accounting.container.js